import { PositionCode } from '@rendora/common/entities/analysis_backend';
import { showDynamicContact } from '@rendora/common/features/contact/index.ts';
import { getI18nService } from '@rendora/common/services/i18n';
import { useUserStore } from '@rendora/common/store/user';
import { IRightsType } from '@rendora/common/types/enums';
import { RIGHTS_TYPES_NEED_CONTACT, RIGHTS_UPGRADE_NEXT } from '../../constants';
import { showBuyEquityModal } from '../buy-equity';
import { showPaymentModal } from '../pay-modal/index';
import UpgradePersonalEquity from './UpgradePersonalEquity.vue';

const upgradeEquitySymbol = Symbol('upgradeEquity');

export const showUpgradeEquityModal = async (): Promise<void> => {
  const userStore = useUserStore();
  const i18nService = getI18nService();
  const $t = i18nService.t;

  if (!userStore.user) return;

  const equityType = RIGHTS_UPGRADE_NEXT[userStore.user.rights_type] ?? userStore.user.rights_type;
  const isPersonalLiteToPersonal =
    equityType === IRightsType.PERSONAL && userStore.user.rights_type === IRightsType.PERSONAL_LITE;

  if (RIGHTS_TYPES_NEED_CONTACT.includes(equityType)) {
    showDynamicContact(PositionCode['有言官网-付费订阅-咨询定制']); // @xi18n-ignore
    return;
  } else if (isPersonalLiteToPersonal) {
    const titleRight = userStore.user.rights_name;
    showPaymentModal(
      <UpgradePersonalEquity defaultRightsType={IRightsType.PERSONAL} />,
      { title: $t('titleright-sheng-ji-tao-can', [titleRight]) },
      upgradeEquitySymbol,
    );
  } else {
    showBuyEquityModal({ targetType: equityType });
  }
};
